"use strict";
/**
 * extracted from ad-config - configurePrebid
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurePrebid = void 0;
var getBidFormat_1 = __importDefault(require("../utils/getBidFormat"));
var normalizeBids_1 = require("../utils/normalizeBids");
var pbjs_major_version = function (version) {
    return parseInt(version === null || version === void 0 ? void 0 : version.split(".")[0].substring(1), 10);
};
var initaliseUserIdConfig = function (pbjs, testGroups) {
    var userIdConfig = [
        {
            name: "criteo",
        },
        {
            name: pbjs_major_version(pbjs.version) < 8 ? "pubCommonId" : "sharedId",
            storage: {
                type: "cookie",
                name: "_pubcid",
                expires: 365,
            },
        },
    ];
    if (testGroups.USE_33ACROSS) {
        userIdConfig.push({
            name: "33acrossId",
            params: {
                pid: "0015a0000341H3PAAU",
            },
            storage: {
                name: "33acrossId",
                type: "html5",
                expires: 90,
                refreshInSeconds: 8 * 3600,
            },
        });
    }
    return userIdConfig;
};
var getPrebidConfig = function (_a) {
    var pbjs = _a.pbjs, userIdConfig = _a.userIdConfig, testGroups = _a.testGroups;
    var prebidConfig = {
        consentManagement: {
            usp: {
                cmpApi: "iab",
                timeout: 100,
            },
        },
        userSync: {
            userIds: userIdConfig,
            filterSettings: {
                iframe: {
                    bidders: "*",
                    filter: "include",
                },
            },
        },
    };
    if (testGroups.GDPR_ADS_EXPERIENCE) {
        prebidConfig.consentManagement.gdpr = {
            cmpApi: "iab",
            timeout: 8000,
            defaultGdprScope: true,
        };
    }
    if (pbjs_major_version(pbjs.version) >= 8) {
        prebidConfig.enableTIDs = true;
    }
    return prebidConfig;
};
var prebidResponseHandler = function (bid) {
    var _a;
    var normalizedBid = (0, normalizeBids_1.normalizeBids)([bid], (0, getBidFormat_1.default)("prebid"))[0];
    if (typeof window.__atha !== "undefined") {
        var ATHABid = {
            adUnitId: bid.adUnitCode,
            partnerId: (_a = normalizedBid === null || normalizedBid === void 0 ? void 0 : normalizedBid.partner) !== null && _a !== void 0 ? _a : "unknown",
            price: normalizedBid === null || normalizedBid === void 0 ? void 0 : normalizedBid.bic,
            dimensions: normalizedBid === null || normalizedBid === void 0 ? void 0 : normalizedBid.dimensions,
        };
        var id = window.__atha.sendBid(ATHABid.adUnitId, ATHABid.partnerId, ATHABid.price, ATHABid.dimensions);
        // this id is used later in the auction_result. Setting this attribute on
        // the bid persists it into the prebid bid object, which will be returned
        // when the auction ends and a winner is decided, so the auction result
        // message can still get at it.
        bid.id = id;
    }
};
/**
 * This helper generates a config using a base template with potential modifications based on any feature flags
 * that might be active and updates the active prebidJS instance to use this config.
 *
 * @param pbjs an instance of prebidJS
 * @param testGroups feature gates that can impact the structure of the generated config
 */
var configurePrebid = function (pbjs, testGroups) {
    // global prebid configuration things.
    // setup user_id module
    // add event listeners
    // these are things we only want to do once
    if (pbjs && pbjs.getEvents && pbjs.getEvents().length === 0) {
        var userIdConfig = initaliseUserIdConfig(pbjs, testGroups);
        var PWT = window.PWT || {};
        if (PWT && PWT.getUserIds) {
            var userIds = PWT.getUserIds();
            if (userIds.tdid) {
                userIdConfig.push({
                    name: "unifiedId",
                    value: {
                        tdid: userIds.tdid,
                    },
                });
            }
        }
        // Created a backlog task to move this. If this is still here,
        // so is the backlog item (https://wattpad.atlassian.net/browse/CP-1025)
        pbjs.onEvent("bidResponse", prebidResponseHandler);
        var prebidConfig = getPrebidConfig({ pbjs: pbjs, userIdConfig: userIdConfig, testGroups: testGroups });
        pbjs.setConfig(prebidConfig);
    }
};
exports.configurePrebid = configurePrebid;
exports.default = {
    configurePrebid: exports.configurePrebid,
};
